import React from "react";
import MetricsContainer from "../../containers/metrics/index";

const MetricsPage = () => <MetricsContainer />;

export default MetricsPage;
